import React from "react";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import styles from "./bottomsheet.module.css"
import BottomSheetModal from "../../BottomSheetModal";
import { ReactComponent as GoldTrophyIcon } from "../../../assets/gold-trophy-icon.svg";
import Accordion from "../../Accordion";
import AccordionItem from "../../Accordion/AccordionItem";
import { useSelector } from "react-redux";
import { getEntryFee, getMaxWinners, getPoolDistribution, getPrizePot } from "../store/actions";
import { _isNil, _map } from "../../../utils/helpers/zupeeLodash";
import { RUPEES_SYMBOL } from "../../../utils/helpers/constants";

interface PrizePoolBottomsheetInterface {
  isOpen: boolean;
  onClose: () => void;
}

const PrizePoolBottomsheet:React.FC<PrizePoolBottomsheetInterface> = ({isOpen, onClose}) => {
  const {t} = useTranslation();
  const totalPrizePot = useSelector(getPrizePot);
  const entryFee = useSelector(getEntryFee);
  const maxWinners = useSelector(getMaxWinners);
  const poolDistribution = useSelector(getPoolDistribution);

  return (
    <>
      <BottomSheetModal
        isOpen={isOpen}
        onClose={onClose}
        modalContentClassName={clsx(styles.modalContent)}
        modalBodyClassName={clsx(styles.modalBody)}
        content= {
          <>
          <div className={clsx(styles.modalHeadingContent)}>
            <div className={clsx(styles.modalTitleBlock, styles.prizePoolBlock, "inlineFlex alignItemCenter justifyContentCenter")}>
              <GoldTrophyIcon />
              <span className={clsx(styles.label, "fontWeightBold fontSizeSm14 fontColorLightBlue")}>{t("prizePool")}</span>
            </div>
            <div className={clsx(styles.gameAmountDetailedBlock)}>
              {!_isNil(totalPrizePot) && (
                <div className={clsx(styles.gameAmount, "fontColorLightBlue fontWeightBold fontSizeSm")}>{RUPEES_SYMBOL} {totalPrizePot}</div>
              )}
              <div className={clsx(styles.gameWinnerDetails, "flex alignItemCenter justifyContentCenter fontWeightBold fontSizeSm12 fontColorLightBlue")}>
                {!_isNil(maxWinners) && (
                  <span className={clsx(styles.winnersDetail)}>{`${maxWinners} ${t("winners")}`}</span>
                )}
                <span className={clsx(styles.separator)}>|</span>
                {!_isNil(entryFee) && (
                  <span className={clsx(styles.entryFeeDetail)}>{`${t("entryFee")} ${entryFee}`}</span>
                )}
              </div>
            </div>
          </div>
          <div className={clsx(styles.modalBodyContent)}>
            <div className={clsx(styles.prizeDistributionBlock)}>
              <div className={clsx(styles.labelRow, "fontSizeSm12 fontColorLightBlue fontWeightRegular flex alignItemCenter justifyContentSB")}>
                <div className={clsx(styles.labelCol)}>{t("rank")}</div>
                <div className={clsx(styles.labelCol)}>{t("prize")}</div>
              </div>
              {_map(poolDistribution, pdItem => (
                <div className={clsx(styles.prizeRow, "flex alignItemCenter justifyContentSB fontSizeSm12 fontColorLightBlue fontWeightBold")} key={pdItem?.label}>
                  {!_isNil(pdItem?.label) && (
                    <div className={clsx(styles.prizeCol)}>{pdItem.label}</div>
                  )}
                  {!_isNil(pdItem?.amt) && (
                    <div className={clsx(styles.prizeCol, "fontSizeSm14 fontWeightBolder")}>{pdItem.amt}</div>
                  )}
                </div>
              ))}
            </div>
            {/* <Accordion>
              <AccordionItem 
              title="Terms & Conditions"
              accordionItemClassName={clsx(styles.accordionItem)}
              accordionHeaderClassName={clsx(styles.tAndCHeader)}
              accordionInnerContentClassName={clsx(styles.accordionContent)}
              >
                <div className={clsx(styles.termsContent, "fontSizeSm12 fontColorLightBlue fontWeightRegular textAlignLeft")}>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. 
                Convallis enim eros, commodo ullamcorper nulla nisl, cras. Quis morbi porttitor augue sagittis ornare non, amet. 
                Consectetur interdum aliquet id placerat euismod phasellus fringilla vulputate malesuada.
                Bibendum sem suscipit feugiat risus at ipsum. Mattis ac condimentum dictum lorem integer.
                </div>
              </AccordionItem>
            </Accordion> */}
          </div>
        </>
        }
      />
    </>
  )
}
export default PrizePoolBottomsheet;